/* eslint-disable */
import { getElementHeight, debounce } from 'app/utils/helpers';
import { accordionTransitionEffect } from 'app/utils/deprecated_accordionTransition';
import mediaQueries from 'app/utils/mediaQueries';

const productDescAccordionTitles = document.querySelectorAll('.product-desc__item > .product-desc__item-title');

if (productDescAccordionTitles.length) {
  const productDescTabContents = document.querySelectorAll('.product-desc__item .product-desc__item-content');
  const defaultActiveTab = document.querySelector('.product-desc__item .product-desc__item-content.active-tab-content');
  const productDescTabsLength = productDescTabContents.length;

  const listenersForFadingEffectHandler = () => {
    const productDescTabTitles = document.querySelectorAll('.product-desc__tab-titles .product-desc__tab-title');
    let correspondingTabID = null;
    let activeTabContent = defaultActiveTab;
    const onTransitionend = event => {
      const element = event.currentTarget;
      if (element.classList.contains('product-desc--fade-out')) {
        [].forEach.call(productDescTabContents, content => {
          content.classList.remove('active-tab-content');
          content.setAttribute('aria-hidden', true);
        });
        activeTabContent = document.querySelector(`#${correspondingTabID}`);
        activeTabContent.setAttribute('aria-hidden', false);
        activeTabContent.classList.add('active-tab-content');
        activeTabContent.classList.add('product-desc--fade-in');
        activeTabContent.style.opacity = 1;
        element.classList.remove('product-desc--fade-out');
      } else {
        activeTabContent.classList.remove('product-desc--fade-in');
      }
    };
    const onTabClick = e => {
      const element = e.currentTarget;
      e.preventDefault();
      if (element.classList.contains('active-tab-title')) {
        return;
      }

      [].forEach.call(productDescTabTitles, title => {
        title.classList.remove('active-tab-title');
        title.setAttribute('aria-selected', false);
      });
      element.classList.add('active-tab-title');
      element.setAttribute('aria-selected', true);
      correspondingTabID = element.getAttribute('aria-controls');
      activeTabContent.classList.add('product-desc--fade-out');
      activeTabContent.style.opacity = 0;
    };
    activeTabContent.classList.add('active-tab-content');
    activeTabContent.setAttribute('aria-hidden', false);
    activeTabContent.style.opacity = 1;
    return {
      add: () => {
        [].forEach.call(productDescTabContents, element => {
          element.addEventListener('transitionend', onTransitionend);
        });
        [].forEach.call(productDescTabTitles, element => {
          element.addEventListener('click', onTabClick);
        });
      },
      remove: () => {
        [].forEach.call(productDescTabContents, element => {
          element.removeEventListener('transitionend', onTransitionend);
          element.classList.remove('active-tab-content');
          element.classList.remove('product-desc--fade-in');
          element.classList.remove('product-desc--fade-out');
          element.style.removeProperty('opacity');
          element.style.removeProperty('height');
        });
        [].forEach.call(productDescTabTitles, element => {
          element.removeEventListener('click', onTabClick);
        });
      },
    };
  };
  let isLargeUp = mediaQueries.is_large_up();
  let fadingHandler = listenersForFadingEffectHandler();
  let accordionHandler = accordionTransitionEffect(productDescAccordionTitles);
  function accordionProductDescSwitch() {
    if (mediaQueries.is_large_up()) {
      fadingHandler.add();
      const elementHeights = [].map.call(productDescTabContents, content => getElementHeight(content));
      const maxHeight = Math.max.apply(null, elementHeights);
      for (let i = 0; i < productDescTabsLength; i++) {
        productDescTabContents[i].style.height = `${maxHeight}px`;
      }
    } else {
      for (let i = 0; i < productDescTabsLength; i++) {
        productDescTabContents[i].setAttribute('aria-hidden', true);
      }
      [].forEach.call(productDescAccordionTitles, element => {
        element.setAttribute('href', `#${element.getAttribute('aria-controls')}`);
      });
      accordionHandler.add();
    }
  }

  if (!isLargeUp) {
    fadingHandler.remove();
  } else {
    accordionHandler.remove();
  }
  accordionProductDescSwitch();

  const debounceTime = 10;

  window.addEventListener(
    'resize',
    debounce(
      () => {
        if (isLargeUp !== mediaQueries.is_large_up()) {
          isLargeUp = mediaQueries.is_large_up();
          accordionHandler.remove();
          fadingHandler.remove();
          if (!isLargeUp) {
            accordionHandler = accordionTransitionEffect(productDescAccordionTitles);
          } else {
            fadingHandler = listenersForFadingEffectHandler();
          }
          accordionProductDescSwitch();
        }
      },
      debounceTime,
      true
    )
  );
}
